import type { InfiniteTablePropColumns } from "@infinite-table/infinite-react";
import type { News } from "epsm-api-types/models";
import type { Dispatch, SetStateAction } from "react";
import { getAlign } from "@/lib/utils";
import { formatDateRelativeToToday } from "@/lib/utils/formatDateRelativeToToday/formatDateRelativeToToday";
import { NEWS_COLUMNS } from "../../../types";
import { NewsRowUI } from "../../../ui/components/NewsRowUI";
import { getClassNameForEstimate } from "../getClassNameForEstimate";
import { getNewsEstimate } from "../getNewsEstimate";
import { getNewsType } from "../getNewsType";

export const getColumns = (
	setColumnOrder: Dispatch<SetStateAction<string[]>>,
	columnOrder: string[],
): InfiniteTablePropColumns<News> => {
	const columns: InfiniteTablePropColumns<News> = {
		publication_date: {
			defaultWidth: 70,
			defaultFilterable: false,
			header: "Date",
			field: "publication_date",
			type: "date",
			headerAlign: "start",
			className: "news-cell",
			align: getAlign("date"),
			valueGetter: ({ data }) =>
				formatDateRelativeToToday(data.publication_date),
		},
		estimate: {
			defaultWidth: 40,
			defaultSortable: false,
			header: "",
			field: NEWS_COLUMNS.SENTIMENT,
			headerAlign: "start",
			align: getAlign("num"),
			className: getClassNameForEstimate,
			valueGetter: ({ data }) =>
				getNewsEstimate(data.sentiment, data.significancy)?.content,
		},
		ticker: {
			defaultFilterable: false,
			defaultWidth: 42,
			header: "Ticker",
			field: NEWS_COLUMNS.TICKER,
			headerAlign: "start",
			className: "news-cell",
			align: getAlign("str"),
			valueGetter: ({ data }) => data.company?.ticker,
		},
		title: {
			className: "news-title",
			header: "Title",
			field: NEWS_COLUMNS.TITLE,
			headerAlign: "start",
			align: getAlign("str"),
			renderRowDetailIcon: true,
			render: ({ data }) => <NewsRowUI data={data} />,
		},
		sector: {
			defaultWidth: 80,
			defaultFilterable: false,
			header: "sector",
			field: NEWS_COLUMNS.SECTOR,
			headerAlign: "start",
			align: getAlign("str"),
		},
		type: {
			defaultWidth: 40,
			defaultFilterable: false,
			header: "type",
			field: NEWS_COLUMNS.DATASET,
			headerAlign: "start",
			align: getAlign("str"),
			valueGetter: getNewsType,
		},
		category: {
			defaultWidth: 40,
			defaultFilterable: false,
			field: NEWS_COLUMNS.CATEGORY,
			align: getAlign("str"),
			valueGetter: ({ data }) => data.category?.join(", "),
		},
	};

	const filteredColumns = Object.fromEntries(
		Object.entries(columns).filter(([key]) => columnOrder.includes(key)),
	);

	setColumnOrder(Object.keys(filteredColumns));

	return filteredColumns;
};
